import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../lib/api";
import { fmtDateTime } from "./AdminUsersTab";

export default function GroupEmailHistory({ reloadKey, t }) {
  const { i18n } = useTranslation();
  const [runs, setRuns] = useState(null);

  useEffect(() => {
    api.get("/admin/group-email/runs").then((r) => setRuns(r.data || [])).catch(() => setRuns([]));
  }, [reloadKey]);

  return (
    <div className="tech-card p-4" data-testid="group-history">
      <div className="label-tech text-slate-400 mb-3">{t("groupEmail.historyTitle")}</div>
      {runs && !runs.length && <div className="text-xs text-slate-500" data-testid="group-history-empty">{t("groupEmail.historyEmpty")}</div>}
      <ul className="divide-y divide-slate-800">
        {(runs || []).map((r) => (
          <li key={r.id} className="py-2 text-xs flex flex-wrap items-center gap-x-3 gap-y-1" data-testid={`group-history-${r.id}`}>
            <span className="text-slate-500 font-mono-data">{fmtDateTime(r.started_at, i18n.language)}</span>
            <span className="text-slate-200 break-words">{r.subject}</span>
            <span className="text-slate-500">{(r.langs || []).map((l) => l.toUpperCase()).join(" · ")}</span>
            <span className="ml-auto font-mono-data text-slate-300">
              {r.sent}/{r.total} ok{r.failed ? <span className="text-rose-300"> · {r.failed} ko</span> : ""}
            </span>
            <span className={`text-[10px] label-tech px-1.5 py-0.5 rounded border ${r.status === "completed" ? "border-emerald-500/40 text-emerald-300" : "border-amber-500/40 text-amber-300"}`}>
              {t(`groupEmail.status_${r.status === "completed" ? "completed" : "running"}`)}
            </span>
            <span className="w-full text-slate-500">{r.admin_email}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
